import { memo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LoadingSpinner, Heading, Row, Col, Alert, Button } from 'reaxl';
import { WALLET_GET_DEAL_DETAILS_WITH_POLLING_REQUEST, WALLET_GET_DEAL_DETAILS_REQUEST, WALLET_GET_DEAL_DETAILS_COMPLETED } from 'wallet-manager';
import { eventBus } from '@atc/cai-event-bus';
import DealCard from '../DealCard/DealCard.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
function DealReceipt(_ref) {
  let {
    dealsDuck,
    inventoryDuck,
    isNDSCompact,
    onEmailCTAClick = () => {},
    paymentsDuck,
    vin,
    ...rest
  } = _ref;
  const walletId = useSelector(paymentsDuck?.selectors?.getWalletId);
  const existingDeal = useSelector(state => dealsDuck?.selectors?.getDealByListingVin(state, vin)) || {};
  const {
    deal,
    vehicle,
    isEcommerce = false
  } = existingDeal;
  const [isLoading, setIsLoading] = useState(false);
  const enableLoading = () => setIsLoading(true);
  const disableLoading = () => setIsLoading(false);
  useEffect(() => {
    eventBus.on(WALLET_GET_DEAL_DETAILS_WITH_POLLING_REQUEST, enableLoading);
    eventBus.on(WALLET_GET_DEAL_DETAILS_REQUEST, enableLoading);
    eventBus.on(WALLET_GET_DEAL_DETAILS_COMPLETED, disableLoading);
    return () => {
      eventBus.off(WALLET_GET_DEAL_DETAILS_WITH_POLLING_REQUEST, enableLoading);
      eventBus.off(WALLET_GET_DEAL_DETAILS_REQUEST, enableLoading);
      eventBus.off(WALLET_GET_DEAL_DETAILS_COMPLETED, disableLoading);
    };
  }, []);
  const handleRetry = () => {
    eventBus.emit(WALLET_GET_DEAL_DETAILS_REQUEST, {
      walletId
    });
  };
  const handleActiveWalletPanel = () => {
    onEmailCTAClick('walletCreditApp');
  };
  const inventory = useSelector(state => inventoryDuck?.selectors?.getInventory(state)) || {};
  const selectedInventory = Object.keys(inventory).filter(listingId => inventory[listingId].vin === vin);
  let dealWithListing;
  if (Object.keys(existingDeal).length) {
    dealWithListing = {
      ...existingDeal,
      vehicle: {
        ...vehicle,
        ...inventory[selectedInventory?.[0]]
      },
      dealer: inventory[selectedInventory?.[0]]?.owner
    };
  }
  const dealType = deal?.dealType;
  let dealHeading = 'Offer Overview';
  if (isEcommerce) {
    dealHeading = 'Order Overview';
  } else if (dealType) {
    dealHeading = `${dealType.charAt(0).toUpperCase() + dealType.slice(1)} Offer Overview`;
  }
  return /*#__PURE__*/jsxs("div", {
    "data-cmp": "dealReceipt",
    children: [isLoading && /*#__PURE__*/jsx(LoadingSpinner, {
      className: "margin-vertical-7"
    }), !isLoading && /*#__PURE__*/jsxs(Fragment, {
      children: [dealWithListing && /*#__PURE__*/jsxs("div", {
        "data-cmp": "dealOverview",
        className: "padding-4",
        children: [/*#__PURE__*/jsx(Heading, {
          className: "text-center",
          size: isNDSCompact ? 500 : 600,
          color: "primary",
          children: dealHeading
        }), /*#__PURE__*/jsx(Row, {
          children: /*#__PURE__*/jsx(Col, {
            xs: 12,
            md: isNDSCompact ? 12 : 6,
            mdOffset: isNDSCompact ? 0 : 3,
            children: /*#__PURE__*/jsx(DealCard, {
              dealData: dealWithListing,
              paymentsDuck: paymentsDuck,
              dealsDuck: dealsDuck,
              indexClicked: 0,
              uiContext: "receipt",
              handleActiveWalletPanel: handleActiveWalletPanel,
              onEmailCTAClick: onEmailCTAClick,
              ...rest
            })
          })
        })]
      }), !dealWithListing && /*#__PURE__*/jsxs(Alert, {
        bsStyle: "warning",
        className: "margin-3 margin-md-7",
        children: ["Whoops! We were unable to fetch your deal details.\xA0", /*#__PURE__*/jsx(Button, {
          bsStyle: "text",
          onClick: handleRetry,
          children: "Try again"
        }), "."]
      })]
    })]
  });
}
var DealReceipt$1 = /*#__PURE__*/memo(DealReceipt);
export { DealReceipt$1 as default };
